export default "__VITE_ASSET__684a92b1__"